import script from "./information.vue?vue&type=script&lang=ts&setup=true"
export * from "./information.vue?vue&type=script&lang=ts&setup=true"

import "./information.vue?vue&type=style&index=0&id=59efa608&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59efa608"]])

export default __exports__